import { IApplicationState } from '../../types/redux';

export const selectUser = (state: IApplicationState) => {
  return state.user;
};
